/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useState } from "react";
import {
  API,
  cddFilterOPtions,
  defaultLimitPagination,
  fileUpload,
  get,
  riskProfile,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../../config";
import { useLocation, useNavigate } from "react-router-dom";
import {
  formatMobile,
  formatName,
  formatPhone,
  getModuleNamingBySlug,
} from "../../../lib/Misc";
import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "../../../components/Pagination";
import { debounce } from "lodash";
import MainBody from "../../../components/MainBody/MainBody";
import sortCaret from "../../../components/SortCaret";
import { useTrust } from "../../../lib/context/TrustContext";
import { Button } from "../../../components/ui/button";
import {
  Calendar,
  CalendarCheck,
  CalendarClockIcon,
  CheckCircle2,
  Clock,
  Clock3,
  RefreshCcw,
  SearchCheck,
} from "lucide-react";
import { useOrganization } from "../../../lib/context/OrganisationContext";
import ExpandCDD from "./ExpandCDD";
import { CaretDownIcon, CaretRightIcon } from "@radix-ui/react-icons";
import CustomTooltip from "../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import VerifyModal from "./VerifyModal";
import RiskChange from "./RiskChange";
import UnauthorisedAccess from "../../../UnauthorisedAccess";
import AddEditContact from "../../Contacts/AddEditContact";
import { AMLCTFModuleConditonIndustry } from "../../../lib/PermissionConditions";
import { useUser } from "../../../lib/context/UserContext";
import AddEditVendor from "../../Vendors/AddEditVendor";
import CDDVerifyModal from "../../../components/Assessment_KYC/CDDVerifyModal";
import CDDVerifyCheck from "../../../components/Assessment_KYC/CDDVerifyCheck";
import KYBReportDownload from "../../../components/Assessment_KYC/KYBReportDownload";
import AdverseMedia from "../../../components/Assessment_KYC/AdverseMedia";
import CDDStatus from "../../../components/Assessment_KYC/CDDStatus";
import { AnimatedTooltip } from "../../../components/AnimatedTooltip";
import moment from "moment";
import { Label } from "../../../components/ui/label";
import CustomLabelText from "../../../components/CustomLabelText";
import SearchSelect from "../../../components/SearchSelect";
import Confirmation from "../../../components/Confirmation";

// * Start: Vendor Listing Page
const SimplifiedCDD = ({ sectionType, readAccess, writeAccess }) => {
  // * Start: Url Management State
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const search = query.get("search");
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const defaultFilter = query.get("filter");
  const { organizationData } = useOrganization();
  const { userData } = useUser();

  let amlCTFEnable =
    (userData?.email === "dchoradiya@gmail.com" ||
      organizationData?.organizationData?.is_aml_ctf_subscribed) &&
    AMLCTFModuleConditonIndustry(organizationData)
      ? true
      : false;

  // * End: Url Management State

  // * Start: List Management State

  const { trustId } = useTrust();
  const [simplifiedCDDsList, setSimplifiedCDDsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  const [cddId, setCddId] = useState("");
  const [cddItem, setCddItem] = useState("");

  const [showVisual, setShowVisual] = useState(false);
  const [showRisk, setShowRisk] = useState(false);

  const [edit, setEdit] = useState(false);
  const [onlyKyc, setOnlyKyc] = useState(false);

  const [contactId, setContactId] = useState(null);
  const [showAddEditContact, setShowAddEditContact] = useState(false);

  const [vendorId, setVendorId] = useState(null);
  const [showAddEditVendor, setShowAddEditVendor] = React.useState(false);

  const [filterValue, setFilterValue] = useState(defaultFilter || null);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [showAllStatus, setShowAllStatus] = useState(false);

  const toggleShowAllStatus = () => {
    setShowAllStatus(!showAllStatus);
  };

  const handleAllStatus = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      for (let i = 0; i < selectedRowIds?.length; i++) {
        formData.append(`kyc_ids[${i}]`, selectedRowIds[i]);
      }
      await fileUpload(`${API.CDD_ALL_KYC_STATUS}`, formData);
      setLoading(false);
      setSelectedRowIds([]);
      fetchSimplifiedCDDs(limit, page);
      toggleShowAllStatus();
    } catch (e) {
      setLoading(false);
      return null;
    }
  };

  const toggleShowAddEditContact = () => {
    if (showAddEditContact) {
      setEdit(false);
      setOnlyKyc(false);
      setContactId(null);
    }
    setShowAddEditContact(!showAddEditContact);
  };

  const toggleShowAddEditVendor = () => {
    if (showAddEditVendor) {
      setEdit(false);
      setOnlyKyc(false);
      setVendorId(null);
    }
    setShowAddEditVendor(!showAddEditVendor);
  };

  // * End: List Management State

  /**
   * * Start: Fetch Vendor List Form The API
   * @param {Number} passLimit (Number of Limit for each page)
   * @param {Number} passPage (Number of Page for records)
   * @returns {Array} Vendor List
   **/

  const fetchSimplifiedCDDs = useCallback(
    async (passLimit, passPage) => {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.GET_CDDS}?limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}&search=${
            searchParam ? searchParam : ""
          }&sort_column=${sortField ? sortField : ""}&sort_order=${
            sortOrder ? sortOrder : ""
          }&trust_id=${trustId}&cdd=0&cdd_customer_type=${sectionType}&organization_id=${
            organizationData?.organizationId
              ? organizationData?.organizationId
              : ""
          }&filter=${filterValue ? filterValue : ""}`,
        );
        setLoading(false);
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        const simplifiedCDDsList = data.data.data;
        setSimplifiedCDDsList(simplifiedCDDsList);
        return data.data;
      } catch (error) {
        setSimplifiedCDDsList([]);
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      searchParam,
      sortOrder,
      sortField,
      trustId,
      sectionType,
      organizationData,
      filterValue,
    ],
  );

  //* End: Fetch Vendor List Form The API

  const toggleVisual = (id, data) => {
    if (showVisual) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setShowVisual(!showVisual);
  };

  const toggleRisk = (id, data) => {
    if (showRisk) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setShowRisk(!showRisk);
  };

  /**
   * * Start: Vendor Table List Record Generation
   * @param {Number} quantity (Number of SimplifiedCDDs)
   * @returns {Array} Vendor List
   **/

  const simplifiedCDDsGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      let smsDate = simplifiedCDDsList[i]?.verifications[0]?.sms_sent_date
        ? simplifiedCDDsList[i]?.verifications[0]?.sms_sent_date
        : "";
      let contact = simplifiedCDDsList[i]?.beneficiary_id
        ? simplifiedCDDsList[i]?.beneficiary
        : simplifiedCDDsList[i]?.vendor_id
          ? simplifiedCDDsList[i]?.vendor
          : simplifiedCDDsList[i]?.contact_id
            ? simplifiedCDDsList[i]?.contact
            : "";

      contact.mobile = contact?.mobile
        ? contact?.mobile[0] === "+"
          ? contact?.mobile
          : `+${contact?.mobile}`
        : "";
      items.push({
        key: simplifiedCDDsList[i]?.id,
        id: simplifiedCDDsList[i]?.id ? simplifiedCDDsList[i]?.id : "",
        contact_type: simplifiedCDDsList[i]?.beneficiary_id
          ? "Beneficiary"
          : simplifiedCDDsList[i]?.vendor_id
            ? getModuleNamingBySlug(
                organizationData?.organizationData,
                "vendors",
                "Vendor",
              )
            : simplifiedCDDsList[i]?.contact_id
              ? getModuleNamingBySlug(
                  organizationData?.organizationData,
                  "contacts",
                  "Customer",
                )
              : "",
        code: contact?.code ? contact?.code : "",
        name:
          formatName(contact?.first_name, contact?.last_name) +
          (contact?.business_name ? ` (${contact?.business_name})` : ""),
        email: contact?.email,
        phone: contact?.phone ? formatPhone(contact?.phone) : "-",
        mobile: contact?.mobile ? formatMobile(contact?.mobile) : "-",
        contact: contact,
        risk: (
          <div className="flex items-center gap-2">
            {simplifiedCDDsList[i]?.risk
              ? riskProfile?.find(
                  (item) => item.value == simplifiedCDDsList[i]?.risk,
                )?.label
              : ""}{" "}
            <CustomTooltip message={"Edit"}>
              <span>
                <FontAwesomeIcon
                  icon={faEdit}
                  size="1x"
                  onClick={() => {
                    toggleRisk(
                      simplifiedCDDsList[i]?.id,
                      simplifiedCDDsList[i],
                    );
                  }}
                />
              </span>
            </CustomTooltip>
          </div>
        ),
        source: simplifiedCDDsList[i]?.source ? (
          simplifiedCDDsList[i]?.source?.includes("(SMS)") ? (
            <div className="flex items-center gap-2">
              {simplifiedCDDsList[i]?.source}{" "}
              {smsDate && (
                <AnimatedTooltip
                  title={
                    <div className="flex items-center gap-4 text-sm">
                      <span>SMS Sent Date:</span>
                      <span className="flex items-center gap-1.5">
                        <Calendar className="h-4 w-4" />
                        {moment(smsDate, "DD-MM-YYYY HH:mm:ss").format(
                          "DD MMM YYYY",
                        )}
                      </span>

                      <span className="flex items-center gap-1.5">
                        <Clock3 className="h-4 w-4" />
                        {moment(smsDate, "DD-MM-YYYY HH:mm:ss").format(
                          "hh:mm:ss A",
                        )}
                      </span>
                    </div>
                  }
                >
                  <CalendarClockIcon className="h-4 w-4 text-webPrimary" />
                </AnimatedTooltip>
              )}
            </div>
          ) : (
            simplifiedCDDsList[i]?.source
          )
        ) : (
          "KYC Incomplete"
        ),
        verifications: simplifiedCDDsList[i]?.verifications
          ? simplifiedCDDsList[i]?.verifications
          : "",
        bureau: (
          <CDDStatus
            cdd="simplified"
            contactType={
              simplifiedCDDsList[i]?.beneficiary_id
                ? "beneficiary"
                : simplifiedCDDsList[i]?.vendor_id
                  ? getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "vendors",
                      "vendor",
                    )
                  : simplifiedCDDsList[i]?.contact_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "contacts",
                        "customer",
                      )
                    : ""
            }
            data={simplifiedCDDsList[i]}
            id={simplifiedCDDsList[i]?.id}
            type={"bureau"}
            fetchData={() => fetchSimplifiedCDDs(limit, page)}
          />
        ),
        dvs: (
          <CDDStatus
            cdd="simplified"
            contactType={
              simplifiedCDDsList[i]?.beneficiary_id
                ? "beneficiary"
                : simplifiedCDDsList[i]?.vendor_id
                  ? getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "vendors",
                      "vendor",
                    )
                  : simplifiedCDDsList[i]?.contact_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "contacts",
                        "customer",
                      )
                    : ""
            }
            data={simplifiedCDDsList[i]}
            id={simplifiedCDDsList[i]?.id}
            type={"dvs"}
            fetchData={() => fetchSimplifiedCDDs(limit, page)}
          />
        ),
        pep: (
          <CDDStatus
            cdd="simplified"
            contactType={
              simplifiedCDDsList[i]?.beneficiary_id
                ? "beneficiary"
                : simplifiedCDDsList[i]?.vendor_id
                  ? getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "vendors",
                      "vendor",
                    )
                  : simplifiedCDDsList[i]?.contact_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "contacts",
                        "customer",
                      )
                    : ""
            }
            data={simplifiedCDDsList[i]}
            id={simplifiedCDDsList[i]?.id}
            type={"pep"}
            fetchData={() => fetchSimplifiedCDDs(limit, page)}
          />
        ),
        sanction: (
          <CDDStatus
            cdd="simplified"
            contactType={
              simplifiedCDDsList[i]?.beneficiary_id
                ? "beneficiary"
                : simplifiedCDDsList[i]?.vendor_id
                  ? getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "vendors",
                      "vendor",
                    )
                  : simplifiedCDDsList[i]?.contact_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "contacts",
                        "customer",
                      )
                    : ""
            }
            data={simplifiedCDDsList[i]}
            id={simplifiedCDDsList[i]?.id}
            type={"sanction"}
            fetchData={() => fetchSimplifiedCDDs(limit, page)}
          />
        ),
        adverse_media: (
          <AdverseMedia
            adverse_media_result={
              simplifiedCDDsList[i]?.summaries[0]?.adverse_media_result
            }
            reference_no={simplifiedCDDsList[i]?.summaries[0]?.request_id}
          />
        ),
        risk_assessment_action: (
          <span className="flex items-center gap-2 justify-center">
            {contact?.kyc?.risk_assessment && (
              <>
                <CustomTooltip
                  message={`Assessment Date: ${contact?.kyc?.risk_assessment?.assessment_date}`}
                >
                  <CalendarCheck size={16} />
                </CustomTooltip>
                <span>/</span>
              </>
            )}
            <CustomTooltip message={"Onboarding Assessment"}>
              <SearchCheck
                size={16}
                onClick={() => {
                  setOnlyKyc(true);
                  setEdit(true);
                  if (simplifiedCDDsList[i]?.vendor_id) {
                    toggleShowAddEditVendor();
                    setVendorId(contact?.id);
                  }
                  if (simplifiedCDDsList[i]?.contact_id) {
                    toggleShowAddEditContact();
                    setContactId(contact?.id);
                  }
                }}
              />
            </CustomTooltip>
          </span>
        ),
        kyc: simplifiedCDDsList[i] ? simplifiedCDDsList[i] : "",
        action:
          simplifiedCDDsList[i]?.source !== "Multiple" ? (
            <>
              <span className="flex items-center gap-2 justify-center">
                {simplifiedCDDsList[i]?.kyb_report_file ? (
                  <KYBReportDownload
                    setLoading={setLoading}
                    kyb_report_file={simplifiedCDDsList[i]?.kyb_report_file}
                  />
                ) : (
                  <></>
                )}
                {(simplifiedCDDsList[i]?.kyb_report_file &&
                  simplifiedCDDsList[i]?.status === 1) ||
                simplifiedCDDsList[i]?.status === 1 ? (
                  <Button
                    size={"sm"}
                    className="bg-green-500 hover:bg-green-600 text-white h-6 px-2"
                  >
                    <div className="flex items-center gap-1">
                      <CheckCircle2 size={14} />
                      <span>Verified</span>
                    </div>
                  </Button>
                ) : (simplifiedCDDsList[i]?.kyb_report_file &&
                    simplifiedCDDsList[i]?.status === 1) ||
                  simplifiedCDDsList[i]?.status === 2 ? (
                  <>
                    <CDDVerifyModal
                      listData={simplifiedCDDsList[i]}
                      setCddItem={setCddItem}
                      setCddId={setCddId}
                      cddItem={cddItem}
                      customerType={contact?.type ? contact?.type : 1}
                      setLoading={setLoading}
                      cddId={cddId}
                      pending={true}
                      sectionType={sectionType}
                      fecthData={fetchSimplifiedCDDs}
                      cdd={0}
                      defaultMobile={
                        contact?.mobile
                          ? contact?.mobile[0] === "+"
                            ? contact?.mobile
                            : `+${contact?.mobile}`
                          : ""
                      }
                      defaultABN={contact?.abn ? contact?.abn : ""}
                    />
                    <Button
                      size={"sm"}
                      className="bg-yellow-500 hover:bg-yellow-600 text-white h-6 px-2"
                    >
                      <div className="flex items-center gap-1">
                        <Clock size={14} />
                        <span>Pending</span>
                      </div>
                    </Button>
                    <CDDVerifyCheck
                      listData={simplifiedCDDsList[i]}
                      setCddId={setCddId}
                      setLoading={setLoading}
                      cddId={cddId}
                      fecthData={fetchSimplifiedCDDs}
                    />
                  </>
                ) : simplifiedCDDsList[i]?.source !== "Visual" ? (
                  simplifiedCDDsList[i]?.source ? (
                    <CDDVerifyModal
                      loading={loading}
                      listData={simplifiedCDDsList[i]}
                      setCddItem={setCddItem}
                      setCddId={setCddId}
                      cddItem={cddItem}
                      customerType={contact?.type ? contact?.type : 1}
                      setLoading={setLoading}
                      cddId={cddId}
                      sectionType={sectionType}
                      fecthData={fetchSimplifiedCDDs}
                      cdd={0}
                      defaultMobile={
                        contact?.mobile
                          ? contact?.mobile[0] === "+"
                            ? contact?.mobile
                            : `+${contact?.mobile}`
                          : ""
                      }
                      defaultABN={contact?.abn ? contact?.abn : ""}
                    />
                  ) : (
                    "KYC Incomplete"
                  )
                ) : (
                  <CustomTooltip message={"Edit"}>
                    <span>
                      <FontAwesomeIcon
                        icon={faEdit}
                        size="1x"
                        onClick={() => {
                          toggleVisual(
                            simplifiedCDDsList[i]?.id,
                            simplifiedCDDsList[i],
                          );
                        }}
                      />
                    </span>
                  </CustomTooltip>
                )}
              </span>
            </>
          ) : (
            <></>
          ),
      });
    }
    return items;
  };

  const simplifiedCDDs = simplifiedCDDsGenerator(simplifiedCDDsList?.length);

  //* End: Vendor Table List Record Generation

  //* Start: Vendor List Columns

  const columns = [
    {
      dataField: "contact_type",
      text: "Type",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "code",
      text: "Code",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    // {
    //   dataField: "phone",
    //   text: "Phone No.",
    //   sort: true,
    //   sortCaret,
    //   headerClasses: THClasses,
    //   classes: TDClasses,
    // },
    {
      dataField: "mobile",
      text: "Mobile No.",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "risk",
      text: "Risk Profile",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "source",
      text: "Source",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "dvs",
      text: "DVS",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "bureau",
      text: "Bureau",
      headerClasses: THClasses,
      classes: TDClasses,
    },

    {
      dataField: "pep",
      text: "PEP",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "sanction",
      text: "Sanction",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    // {
    //   headerClasses: THClasses,
    //   classes: TDClasses,
    //   dataField: "risk_assessment_action",
    //   text: "Onboarding",
    //   align: "center",
    //   headerAlign: "center",
    // },
    {
      dataField: "adverse_media",
      text: "Adverse Media",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "action",
      text: "Action",
      align: "center",
      headerAlign: "center",
      style: { width: "127px" },
    },
  ];

  //* End: Vendor List Columns

  /**
   * * Start: Vendor List Sorting
   * @param {type} (Sort)
   * @param {JSON} (page, sortField, sortOrder) (To get the current value of the table)
   **/
  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC",
      );
    }
  };

  //* End: Vendor List Sorting

  /**
   * * Start: Vendor List Change Limit
   * @param {Event} e (Limit Number)
   **/
  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchSimplifiedCDDs(limit, 1);
  };

  //* End: Vendor List Change Limit

  /**
   * * Start: Vendor List Change Page
   * @param {Number} page (Page Number)
   **/
  const handleChangePage = (page) => {
    setPage(page);
    fetchSimplifiedCDDs(limit, page);
  };

  //* End: Vendor List Change Page

  //* Start: Vendor List and URL Mangement useEffect

  useEffect(() => {
    fetchSimplifiedCDDs();
  }, [fetchSimplifiedCDDs]);

  //* End: Vendor List and URL Mangement useEffect

  //* Start: Vendor List Search Record Management

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    [],
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    if (nextValue?.length >= 2 || nextValue?.length === 0) {
      debouncedSave(nextValue);
    }
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  //* End: Vendor List Search Record Management

  const expandRow = {
    renderer: (row) => (
      <>
        <ExpandCDD
          expandList={true}
          expandData={row?.verifications}
          kyc={row?.kyc}
          loading={loading}
          setLoading={setLoading}
          fetchCDDs={fetchSimplifiedCDDs}
          sectionType={sectionType}
          contact={row?.contact}
        />
      </>
    ),
    onlyOneExpanding: true,
    showExpandColumn: true,
    expandByColumnOnly: true,
    headerClasses: THClasses,
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <CaretDownIcon />;
      }
      return <CaretRightIcon />;
    },
    className: TDClasses,
    expandHeaderColumnRenderer: () => {
      return <></>;
    },
  };

  const arrayRemove = (arr, value) => {
    return arr.filter(function (ele) {
      return ele !== value;
    });
  };

  const selectRow = {
    mode: "checkbox",
    clickToSelect: false,
    selected: selectedRowIds,
    onSelectAll: (row, isSelect) => {
      if (simplifiedCDDsList?.length > 0) {
        if (row) {
          const ids =
            isSelect &&
            isSelect?.length > 0 &&
            isSelect?.map((item) => {
              return item?.key;
            });
          setSelectedRowIds(selectedRowIds ? selectedRowIds.concat(ids) : ids);
        } else {
          const removableData =
            isSelect &&
            isSelect?.length > 0 &&
            isSelect.map(function (data) {
              return data?.key;
            });
          setSelectedRowIds(
            selectedRowIds
              ? selectedRowIds.filter((item) => !removableData.includes(item))
              : [],
          );
        }
      }
    },
    onSelect: (row, isSelect) => {
      if (isSelect) {
        setSelectedRowIds((keys) => [...keys, row?.key]);
      } else {
        setSelectedRowIds(arrayRemove(selectedRowIds, row?.key));
      }
    },
  };

  useEffect(() => {
    navigate(
      `?tab=cdd&childTab=${sectionType == 1 ? "ongoing" : "initial"}&subChildTab=simplified&limit=${
        limit ? limit : defaultLimitPagination
      }&page=${page ? page : 1}&sort_column=${
        sortField ? sortField : ""
      }&sort_order=${sortOrder ? sortOrder : ""}&filter=${filterValue ? filterValue : ""}`,
      {
        replace: true,
      },
    );
  }, [navigate, limit, page, sortField, sortOrder, sectionType, filterValue]);

  return readAccess ? (
    <>
      <MainBody
        searchParamData={searchParamData}
        handleClearSearch={handleClearSearch}
        handleSearchChange={handleSearchChange}
        actionContent={
          <>
            <div className="flex items-center gap-2">
              <div className="grid gap-2">
                <div className="min-w-0 flex items-center gap-2">
                  <Label htmlFor="aml_ctf_contact_id">
                    <CustomLabelText
                      labelText="Filter by:"
                      errorField={""}
                    />
                  </Label>
                  <div className="relative">
                    <SearchSelect
                      frameworks={cddFilterOPtions}
                      optionType={"Filter by"}
                      handleSelect={(e) => {
                        setFilterValue(e);
                      }}
                      clearable={true}
                      initialValue={filterValue ? filterValue : ""}
                      onClear={() => {
                        setFilterValue(null);
                      }}
                    />
                  </div>
                </div>
              </div>
              {filterValue == "pending" && (
                <Button
                  size={"sm"}
                  className="px-2"
                  disabled={selectedRowIds?.length == 0}
                  onClick={() => {
                    toggleShowAllStatus();
                  }}
                >
                  <div className="flex items-center gap-2">
                    <RefreshCcw size={14} />
                    <span>Show All</span>
                  </div>
                </Button>
              )}
            </div>
          </>
        }
        loading={loading}
        innerBody={true}
        parentHeight={true}
        mainClassName="w-[calc(100%-3rem)]"
      >
        {/* Vendor Table and Pagination */}
        <div className="custom-table">
          <div className="table-body-class max-h-[52vh] overflow-y-auto">
            <BootstrapTable
              keyField="id"
              remote
              data={simplifiedCDDs}
              columns={columns}
              onTableChange={handleTableChange}
              selectRow={selectRow}
              expandRow={expandRow}
              rowClasses={TRClasses}
              noDataIndication="No Data Found"
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>

          <Pagination
            total={total}
            limit={parseInt(limit)}
            currentPage={page}
            updateLimit={handleUpdateLimit}
            updatePage={handleChangePage}
            from={from}
            to={to}
          />
        </div>

        {showVisual && (
          <ResponsiveDrawerForm
            description={""}
            title={`Visual Changes`}
            handleOpen={() => {}}
            handleClose={() => {
              toggleVisual();
            }}
            write={true}
            buttonText={""}
            className={"sm:max-w-3xl"}
            open={showVisual}
            buttonClassName={""}
            setOpen={setShowVisual}
            popupType={"cdds"}
          >
            <VerifyModal
              data={cddItem?.verifications[0]}
              toggleVisual={toggleVisual}
              fetchData={fetchSimplifiedCDDs}
            />
          </ResponsiveDrawerForm>
        )}

        {showRisk && (
          <ResponsiveDrawerForm
            description={""}
            title={`Risk Change`}
            handleOpen={() => {}}
            handleClose={() => {
              toggleRisk();
            }}
            write={true}
            buttonText={""}
            className={"sm:max-w-3xl"}
            open={showRisk}
            popupType={"cdds"}
            buttonClassName={""}
            setOpen={setShowRisk}
          >
            <RiskChange
              data={cddItem}
              toggleRisk={toggleRisk}
              fetchData={fetchSimplifiedCDDs}
            />
          </ResponsiveDrawerForm>
        )}

        {contactId ? (
          <ResponsiveDrawerForm
            description={""}
            title={
              onlyKyc
                ? `Contact Onboarding Assessment`
                : edit
                  ? `Edit ${getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "contacts",
                      "Customer",
                    )}`
                  : `Add ${getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "contacts",
                      "Customer",
                    )}`
            }
            handleOpen={() => {}}
            handleClose={() => {
              setEdit(false);
              setOnlyKyc(false);
              setContactId(null);
              setShowAddEditContact(false);
            }}
            buttonText={""}
            className={"overflow-hidden"}
            open={showAddEditContact}
            buttonClassName={""}
            setOpen={setShowAddEditContact}
            write={true}
          >
            <AddEditContact
              edit={edit}
              toggleShowAddEditContact={toggleShowAddEditContact}
              id={contactId}
              setEdit={setEdit}
              onlyKyc={onlyKyc}
              trustId={trustId}
              fetchContactData={() => fetchSimplifiedCDDs(limit, page)}
              org={true}
              amlCTFEnable={amlCTFEnable}
            />
          </ResponsiveDrawerForm>
        ) : vendorId ? (
          <>
            <ResponsiveDrawerForm
              description={""}
              title={
                onlyKyc
                  ? `Vendor Onboarding Assessment`
                  : edit
                    ? `Edit ${getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "Vendor",
                      )}`
                    : `Add ${getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "Vendor",
                      )}`
              }
              handleOpen={() => {}}
              handleClose={() => {
                setEdit(false);
                setOnlyKyc(false);
                setVendorId(null);
                setShowAddEditVendor(false);
              }}
              buttonText={""}
              className={"overflow-hidden"}
              open={showAddEditVendor}
              buttonClassName={""}
              setOpen={setShowAddEditVendor}
              mobileCancelHidden={true}
              write={true}
            >
              <AddEditVendor
                edit={edit}
                setEdit={setEdit}
                onlyKyc={onlyKyc}
                toggleShowAddEditVendor={toggleShowAddEditVendor}
                vendorID={vendorId}
                fetchVendors={() => fetchSimplifiedCDDs(limit, page)}
                org={true}
                amlCTFEnable={amlCTFEnable}
              />
            </ResponsiveDrawerForm>
          </>
        ) : (
          <></>
        )}

        <Confirmation
          title={`Check All Pending Status`}
          open={showAllStatus}
          setOpen={setShowAllStatus}
          toggleShow={() => {
            toggleShowAllStatus();
          }}
          className="sm:max-w-fit"
          popupType={"cdds"}
          message={
            <>
              <p>Would you like to check all the kyc verification status?</p>
            </>
          }
          okAction={async () => {
            handleAllStatus();
          }}
          loading={loading}
          cancelAction={async () => {
            toggleShowAllStatus();
          }}
        />
      </MainBody>
    </>
  ) : (
    <UnauthorisedAccess expandList={true} popup={true} />
  );
};

export default SimplifiedCDD;
// * End: Vendor Listing Page
